import { Component } from '@angular/core';

@Component({
    selector: 'app-panel-inherited',
    template: '<ng-content></ng-content>'
})
export class PanelInheritedComponent {

}
